import { AnalyticIdentifier, assertNever } from '@common/neo.tax';

import { ProviderType } from '@neo.tax/shared/graphql';

interface BulkEditProviderInfo {
  title: string;
  analyticIds: {
    download: AnalyticIdentifier;
    upload: AnalyticIdentifier;
  };
}

export const getBulkEditProviderInfo = (providerType: ProviderType): BulkEditProviderInfo => {
  switch (providerType) {
    case ProviderType.Accounting:
      return {
        title: 'Bulk Edit Accounting Expense and Project Allocations',
        analyticIds: {
          download: AnalyticIdentifier.ENTERPRISE_DOWNLOAD_ACCOUNTING_PROJECT_ALLOCATION_REPORT,
          upload: AnalyticIdentifier.ENTERPRISE_UPLOAD_ACCOUNTING_PROJECT_ALLOCATION_REPORT,
        },
      };
    case ProviderType.Payroll:
      return {
        title: 'Bulk Edit Payroll Expense and Project Allocations',
        analyticIds: {
          download: AnalyticIdentifier.ENTERPRISE_DOWNLOAD_PAYROLL_PROJECT_ALLOCATION_REPORT,
          upload: AnalyticIdentifier.ENTERPRISE_UPLOAD_PAYROLL_PROJECT_ALLOCATION_REPORT,
        },
      };
    case ProviderType.Ticketing:
    case ProviderType.PayrollMonthExpenses:
      throw new Error('Does not support bulk edit for ticketing providers or ASC Cost yet');
    default:
      assertNever(providerType);
  }
};
